<template>
  <div style="display: flex; flex-wrap: wrap">
    <slot name="pre-append" />
    <el-button-group v-if="!timeType" :style="styleValue">
      <el-button
        :size="$xUISize"
        :disabled="disabled"
        @click="onModeClick('today')"
        :type="mode == 'today' ? 'primary' : 'default'"
      >
        今天
      </el-button>
      <el-button
        :size="$xUISize"
        :disabled="disabled"
        @click="onModeClick('day')"
        :type="mode == 'day' ? 'primary' : 'default'"
      >
        按天
      </el-button>
      <el-button
        :size="$xUISize"
        :disabled="disabled"
        @click="onModeClick('week')"
        :type="mode == 'week' ? 'primary' : 'default'"
      >
        按周
      </el-button>
      <el-button
        :size="$xUISize"
        :disabled="disabled"
        @click="onModeClick('month')"
        :type="mode == 'month' ? 'primary' : 'default'"
      >
        按月
      </el-button>
    </el-button-group>
    <el-button-group
      :disabled="disabled"
      v-if="mode != 'today' && !timeType"
      :style="styleValue"
    >
      <el-button
        icon="el-icon-arrow-left"
        @click="timeBackClick"
        :size="$xUISize"
        :disabled="disabled"
      ></el-button>
      <el-button
        icon="el-icon-arrow-right"
        @click="timeNextClick"
        :size="$xUISize"
        :disabled="disabled"
      ></el-button>
    </el-button-group>
    <el-date-picker
      v-if="mode == 'month'"
      v-model="inputValue"
      :style="styleValuePicker"
      :size="$xUISize"
      :editable="false"
      :clearable="false"
      :disabled="disabled"
      @change="onDateTime"
      placeholder="选择月"
      type="month"
      key="month"
    >
    </el-date-picker>
    <el-date-picker
      v-if="mode == 'week'"
      v-model="inputValue"
      :style="styleValuePicker"
      :size="$xUISize"
      :editable="false"
      :clearable="false"
      :disabled="disabled"
      format="yyyy 第 WW 周"
      @change="onDateTime"
      placeholder="选择周"
      type="week"
      key="week"
    >
    </el-date-picker>
    <el-date-picker
      v-if="mode == 'day'"
      v-model="inputValue"
      :style="styleValuePicker"
      :size="$xUISize"
      :editable="false"
      :clearable="false"
      :disabled="disabled"
      @change="onDateTime"
      placeholder="选择日期"
      type="date"
      key="date"
    >
    </el-date-picker>
    <slot name="append" />
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  data() {
    return {
      mode: "-",
      selectTimes: [],
      inputValue: null,
    };
  },
  computed: {
    styleValue() {
      if (!!this.timeType) {
        return {};
      }
      return {
        "margin-right": "10px",
        "margin-bottom": "10px",
      };
    },
    styleValuePicker() {
      return Object.assign(
        {
          width: "160px",
        },
        this.styleValue
      );
    },
  },
  props: {
    cache: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    timeType: {
      type: String,
    },
  },
  watch: {
    timeType() {
      this.initTimeType();
    },
  },
  methods: {
    initTimeType() {
      if (this.timeType) {
        this.onModeClick(this.timeType);
      }
    },
    onModeClick(mode) {
      this.mode = mode;
      this.handleTimeRefresh();
      this.handleInputConfirm();
    },
    timeBackClick() {
      try {
        if (this.mode == "day") {
          this.inputValue = dayjs(this.inputValue).subtract(1, "day").toDate();
        } else if (this.mode == "week") {
          this.inputValue = dayjs(this.inputValue).subtract(7, "day").toDate();
        } else if (this.mode == "month") {
          let curDay = dayjs(this.inputValue);
          this.inputValue = curDay
            .date(1)
            .month(curDay.month() - 1)
            .toDate();
        }
        this.onDateTime();
      } catch (error) {}
    },
    timeNextClick() {
      try {
        if (this.mode == "day") {
          this.inputValue = dayjs(this.inputValue).add(1, "day").toDate();
        } else if (this.mode == "week") {
          this.inputValue = dayjs(this.inputValue).add(7, "day").toDate();
        } else if (this.mode == "month") {
          let curDay = dayjs(this.inputValue);
          this.inputValue = curDay
            .date(1)
            .month(curDay.month() + 1)
            .toDate();
        }
        this.onDateTime();
      } catch (error) {}
    },
    handleTimeRefresh() {
      if (this.mode == "today") {
        this.selectTimes = [
          new Date(new Date().toLocaleDateString()).getTime(),
          new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
        ];
      } else if (this.mode == "day") {
        this.inputValue = new Date();
        this.onDateTime();
      } else if (this.mode == "week") {
        this.inputValue = new Date();
        this.onDateTime();
      } else if (this.mode == "month") {
        this.inputValue = new Date();
        this.onDateTime();
      }
    },
    onDateTime() {
      let curDate = dayjs(this.inputValue);
      const endTime = curDate.endOf(this.mode).valueOf();
      const startTime = curDate.startOf(this.mode).valueOf();
      this.selectTimes = [startTime, endTime];
      this.handleInputConfirm();
    },
    handleInputConfirm() {
      if (this.selectTimes && this.selectTimes.length >= 2) {
        if (this.cache) {
          try {
            localStorage.setItem(
              "--time-range-value",
              JSON.stringify({
                mode: this.mode,
                selectTimes: this.selectTimes,
              })
            );
          } catch (e) {}
        }
        this.$emit("change", {
          startDate: new Date(this.selectTimes[0]).format("YYYY-MM-dd"),
          endDate: new Date(this.selectTimes[1]).format("YYYY-MM-dd"),
        });
      }
    },
  },
  mounted() {
    if (this.cache) {
      try {
        let val = JSON.parse(localStorage.getItem("--time-range-value"));
        this.selectTimes = val.selectTimes || [
          new Date(new Date().toLocaleDateString()).getTime(),
          new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
        ];
        this.mode = val.mode || "today";
      } catch (e) {
        this.mode = "today";
      }
    } else {
      this.mode = "today";
    }
    this.initTimeType();
    this.handleTimeRefresh();
    this.handleInputConfirm();
  },
};
</script>
